import { converterDataBr } from "_utils/Data";
import { CompositeContainer } from "components/CompositeContainer";
import { Table } from "containers/Table";
import { makeWorker } from "features/processo/_workers";
import { useCadastrarProcesso } from "features/processo/hooks/useCadastrarProcesso";
import { CadastrarProcessoEmLoteMapper } from "features/processo/utils/mappers/CadastrarProcessoEmLoteMapper";
import { useMemo, useState } from "react";
import { ModalProcessosCadastrados } from "../ModalProcessosCadastrados";
import { handleExportProcessos } from "../ModalProcessosCadastrados/utils/ExportarPlanilhaErro";
import { ModalCertezaProcessosDuplicados } from "../ModalCertezaProcessosDuplicados";
import { alertaErro } from "components/Alerta";
import { ModalEscolherTipoVeiculo } from "../ModalEscolherTipoVeiculo";
import { ModalEscolherMarcaModelo } from "../ModalEscolherMarcaModelo";
import { FaPen } from "react-icons/fa";
import { ModalDadosTabelaAcaoNecessaria } from "../ModalDadosTabelaAcaoNecessaria";

export function ListarProcessosPlanilha({ setLoadingPage }: any) {
  const [dadosTabela, setDadosTabela] = useState<any[]>([]);
  const [dadosServico, setDadosServico] = useState<any>({});
  const [showModal, setShowModal] = useState(false);
  const [
    showModalCertezaProcessosDuplicados,
    setShowModalCertezaProcessosDuplicados,
  ] = useState(false);

  const { cadastrarProcessos, processosComErro, handleLimparProcessosComErro } =
    useCadastrarProcesso();
  const worker = useMemo(makeWorker, []);
  const [chassiEscolhido, setChassiEscolhido] = useState<string>("");
  const [showModalEscolherTipoVeiculo, setShowModalEscolherTipoVeiculo] =
    useState<boolean>(false);
  const [showModalEscolherMarcaModelo, setShowModalEscolherMarcaModelo] =
    useState<boolean>(false);
  const [showModalDadosTabelaAcao, setShowModalDadosTabelaAcao] =
    useState<boolean>(false);

  const onClickEscolherTipoVeiculo = (chassi: NullableString) => {
    if (!chassi) {
      alertaErro("Chassi é obrigatório");
      return;
    }
    setChassiEscolhido(chassi);
    setShowModalEscolherTipoVeiculo(true);
  };

  const onClickEscolherMarcaModelo = (chassi: NullableString) => {
    if (!chassi) {
      alertaErro("Chassi é obrigatório");
      return;
    }
    setChassiEscolhido(chassi);
    setShowModalEscolherMarcaModelo(true);
  };

  const columns = [
    {
      name: <span>Placa</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.placa ?? "- -"}</span>
      ),
    },
    {
      name: <span>Chassi</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.chassi ?? "- -"}</span>
      ),
      width: "170px",
    },
    {
      name: <span>Renavam</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.renavam ?? "- -"}</span>
      ),
    },
    {
      name: <span>Odômetro</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.odometro ?? "- -"}</span>
      ),
    },
    {
      name: <span>UF</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.uf ?? "- -"}</span>
      ),
    },
    {
      name: <span>Município</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.municipio ?? "- -"}</span>
      ),
    },
    {
      name: <span>Tipo</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span onClick={() => onClickEscolherTipoVeiculo(veiculo.chassi)}>
          <FaPen style={{ cursor: "pointer", marginRight: 8 }} />
          {veiculo?.tipo ?? "- -"}
        </span>
      ),
      width: "130px",
    },
    {
      name: <span>Marca/Modelo</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span onClick={() => onClickEscolherMarcaModelo(veiculo.chassi)}>
          <FaPen style={{ cursor: "pointer", marginRight: 8 }} />
          {veiculo?.marcaModelo ?? "- -"}
        </span>
      ),
      width: "300px",
    },
    {
      name: <span>Ano Modelo</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.anoModelo ?? "- -"}</span>
      ),
      width: "100px",
    },
    {
      name: <span>Ano Fabricação</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.anoFabricacao ?? "- -"}</span>
      ),
      width: "100px",
    },
    {
      name: <span>Cor</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.cor ?? "- -"}</span>
      ),
    },
    {
      name: <span>Espécie</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.especie ?? "- -"}</span>
      ),
    },
    {
      name: <span>Potência</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.potencia ?? "- -"}</span>
      ),
    },
    {
      name: <span>Combustível</span>,
      selector: ({ veiculo }: CadastrarProcessoEmLoteMapper) => (
        <span>{veiculo?.combustivel ?? "- -"}</span>
      ),
    },
    {
      name: <span>CPF/CNPJ</span>,
      selector: ({ cliente }: CadastrarProcessoEmLoteMapper) => (
        <span>{cliente?.cpfCnpj ?? "- -"}</span>
      ),
    },
    {
      name: <span>Nome</span>,
      selector: ({ cliente }: CadastrarProcessoEmLoteMapper) => (
        <span>{cliente?.nome ?? "- -"}</span>
      ),
    },
    {
      name: <span>E-mail</span>,
      selector: ({ cliente }: CadastrarProcessoEmLoteMapper) => (
        <span>{cliente?.email ?? "- -"}</span>
      ),
    },
    {
      name: <span>CEP</span>,
      selector: ({ cliente }: CadastrarProcessoEmLoteMapper) => (
        <span>{cliente?.cep ?? "- -"}</span>
      ),
    },
    {
      name: <span>Endereço</span>,
      selector: ({ cliente }: CadastrarProcessoEmLoteMapper) => (
        <span>{cliente?.endereco ?? "- -"}</span>
      ),
    },
    {
      name: <span>Número</span>,
      selector: ({ cliente }: CadastrarProcessoEmLoteMapper) => (
        <span>{cliente?.numero ?? "- -"}</span>
      ),
    },
    {
      name: <span>Complemento</span>,
      selector: ({ cliente }: CadastrarProcessoEmLoteMapper) => (
        <span>{cliente?.complemento ?? "- -"}</span>
      ),
    },
    {
      name: <span>Bairro</span>,
      selector: ({ cliente }: CadastrarProcessoEmLoteMapper) => (
        <span>{cliente?.bairro ?? "- -"}</span>
      ),
    },
    {
      name: <span>UF</span>,
      selector: ({ cliente }: CadastrarProcessoEmLoteMapper) => (
        <span>{cliente?.ufCliente ?? "- -"}</span>
      ),
    },
    {
      name: <span>Valor de Venda</span>,
      selector: ({ servicoTransferencia }: CadastrarProcessoEmLoteMapper) => (
        <span>{servicoTransferencia?.valorDeVenda ?? "- -"}</span>
      ),
    },
    {
      name: <span>UF Venda</span>,
      selector: ({ servicoTransferencia }: CadastrarProcessoEmLoteMapper) => (
        <span>{servicoTransferencia?.ufVenda ?? "- -"}</span>
      ),
    },
    {
      name: <span>Município de Venda</span>,
      selector: ({ servicoTransferencia }: CadastrarProcessoEmLoteMapper) => (
        <span>{servicoTransferencia?.municipioDeVenda ?? "- -"}</span>
      ),
    },
    {
      name: <span>Data de Venda</span>,
      selector: ({ servicoTransferencia }: CadastrarProcessoEmLoteMapper) => (
        <span>
          {servicoTransferencia?.dataDeVenda
            ? converterDataBr(new Date(servicoTransferencia?.dataDeVenda))
            : "- -"}
        </span>
      ),
    },
    {
      name: <span>Escolha de Placa</span>,
      selector: ({ servicoEmplacamento }: CadastrarProcessoEmLoteMapper) => (
        <span>{servicoEmplacamento?.escolhaDePlaca ?? "- -"}</span>
      ),
    },
    {
      name: <span>Local de Emplacamento</span>,
      selector: ({ servicoEmplacamento }: CadastrarProcessoEmLoteMapper) => (
        <span>{servicoEmplacamento?.localDeEmplacamento ?? "- -"}</span>
      ),
      width: "225px",
    },
    {
      name: <span>Placa Vermelha</span>,
      selector: ({ servicoEmplacamento }: CadastrarProcessoEmLoteMapper) => (
        <span>{servicoEmplacamento?.placaVermelha ?? "- -"}</span>
      ),
    },
    {
      name: <span>Alienação</span>,
      selector: ({ servicoEmplacamento }: CadastrarProcessoEmLoteMapper) => (
        <span>{servicoEmplacamento?.alienacao ?? "- -"}</span>
      ),
    },
    {
      name: <span>NF</span>,
      selector: ({ servicoEmplacamento }: CadastrarProcessoEmLoteMapper) => (
        <span>{servicoEmplacamento?.nf?.toString() ?? "- -"}</span>
      ),
      width: "225px",
    },
    {
      name: <span>Emissão</span>,
      selector: ({ servicoEmplacamento }: CadastrarProcessoEmLoteMapper) => (
        <span>
          {servicoEmplacamento?.emissao
            ? converterDataBr(new Date(servicoEmplacamento?.emissao))
            : "- -"}
        </span>
      ),
    },
  ];

  worker.onmessage = async ({ data }: any) => {
    const { type, dados, dadosServico } = data;

    if (dados.some((dado: any) => dado.veiculo.jaExistemProcessos)) {
      setShowModalCertezaProcessosDuplicados(true);
    }

    if (type === "dadosExcel" && dados && dadosServico) {
      setDadosServico(dadosServico);
      setDadosTabela(dados);
      setLoadingPage(false);
    }
  };

  async function handleSalvarExcel() {
    setLoadingPage(true);
    await cadastrarProcessos(dadosTabela, dadosServico);
    setLoadingPage(false);
    setShowModal(true);
  }

  const onCloseModalProcessosDuplicados = () => {
    setDadosTabela([
      ...dadosTabela.filter((dado) => !dado.veiculo.jaExistemProcessos),
    ]);

    setShowModalCertezaProcessosDuplicados(false);
  };

  const handleDadosTabelaAcao = () => {
    if (dadosTabela.filter((dado) => dado.veiculo.status != "OK").length) {
      setShowModalDadosTabelaAcao(true);
      return;
    }
    setShowModalDadosTabelaAcao(false);
  };

  return (
    <CompositeContainer.Root>
      <CompositeContainer.Header>
        <CompositeContainer.Titulo text="Resultado" />
        <CompositeContainer.ActionButton
          text="Salvar Excel"
          onClick={handleSalvarExcel}
          disabled={dadosTabela.length === 0}
        />
      </CompositeContainer.Header>
      <CompositeContainer.Body>
        <Table
          columns={columns}
          data={dadosTabela}
          keyField={`id${dadosTabela.length}`}
          loading={false}
          noSubHeader={true}
          totalRows={dadosTabela.length}
        />
      </CompositeContainer.Body>
      <ModalProcessosCadastrados
        handleClose={() => {
          handleLimparProcessosComErro();
          setShowModal(false);
        }}
        soTeveErro={processosComErro.length === dadosTabela.length}
        processosComErro={processosComErro}
        show={showModal}
        onConfirm={() => {
          handleExportProcessos(processosComErro, setShowModal);
        }}
      />
      <ModalCertezaProcessosDuplicados
        show={showModalCertezaProcessosDuplicados}
        handleClose={() => {
          onCloseModalProcessosDuplicados();
          handleDadosTabelaAcao();
        }}
        onConfirm={() => {
          setShowModalCertezaProcessosDuplicados(false);
          handleDadosTabelaAcao();
        }}
      />
      <ModalEscolherTipoVeiculo
        setDadosTabela={setDadosTabela}
        dadosTabela={dadosTabela}
        chassi={chassiEscolhido}
        show={showModalEscolherTipoVeiculo}
        handleClose={() => {
          setShowModalEscolherTipoVeiculo(false);
          setChassiEscolhido("");
        }}
        setShow={setShowModalEscolherTipoVeiculo}
      />
      <ModalEscolherMarcaModelo
        setDadosTabela={setDadosTabela}
        dadosTabela={dadosTabela}
        chassi={chassiEscolhido}
        show={showModalEscolherMarcaModelo}
        handleClose={() => {
          setShowModalEscolherMarcaModelo(false);
          setChassiEscolhido("");
        }}
        setShow={setShowModalEscolherMarcaModelo}
      />
      <ModalDadosTabelaAcaoNecessaria
        handleClose={() => setShowModalDadosTabelaAcao(false)}
        show={showModalDadosTabelaAcao}
        qtdAcaoNecessaria={
          dadosTabela.filter((dado) => dado.veiculo.status === "ACAO").length
        }
        qtdAlteradosAutomaticamente={
          dadosTabela.filter((dado) => dado.veiculo.status === "ALTERADO")
            .length
        }
        qtdSucesso={
          dadosTabela.filter((dado) => dado.veiculo.status === "OK").length
        }
      />
    </CompositeContainer.Root>
  );
}
